import usePermission from '../hooks/usePermission';
import NoPermissionPage from '../components/common/NoPermissionPage';
import LoadingSpinner from '../components/common/LoadingSpinner/LoadingSpinner';

export default function PermissionRoute({ perm, children }) {
  const { has, meLoading } = usePermission();
  if (meLoading)
    return (
      <div className="py-5 d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <LoadingSpinner />
      </div>
    );
  // An array means "any of these" — a page with two permission sets behind it
  // (in-house vouchers and public passes) opens for either.
  const allowed = Array.isArray(perm) ? perm.some((p) => has(p)) : has(perm);
  if (!allowed) return <NoPermissionPage />;

  return children;
}
